<template>
<div>
	<div v-if="showList">
		<div class="d-flex justify-content-between align-items-center">
			<h2>
				RFIs
				<br>
				<small>Project #{{$store.project.job_num}}, {{$store.project.job_name}}</small>
			</h2>

			<button class="btn btn-success" v-on:click="newRfi">
				<i class="fa fa-plus"></i>
				New RFI
			</button>
		</div>

		<table-list
			record-name="RFI"
			:fields="fields"
			:records="mutatedRfis"
			:hide-record-count="true"
			:has-edit="true"
			v-on:edit="editRfi">
		</table-list>
	</div>

	<collapsible-panel v-else :always-open="true" panel-size="sm">
		<template slot="panel">
			<h3>RFI</h3>

			<panel-menu
				:menu-items="menuItems"
				:active-item="activeSection"
				v-on:itemClick="activateSection">
			</panel-menu>
		</template>

		<template slot="main">
			<i class="fa fa-times icon-button close-edit" v-on:click="backToList"></i>

			<p><a href="#" v-on:click.prevent="backToList">
				<i class="fa fa-arrow-left"></i>
				Back to RFIs
			</a></p>

			<div class="row">
				<div v-if="activeSection != 'Delivery'" class="col-lg-6">
					<vue-form
						v-on:submit="saveRfi"
						size="sm"
						:no-top-button="true"
						:readonly="selectedRfi.is_finalized == 1 || selectedRfi.status == 'Closed'"
						:working="working">

						<div v-show="activeSection == 'Details'">

							<field
								v-if="'id' in selectedRfi"
								label="Status"
								col-class="col-md-4"
								:params="{type:'select',options:rfiStatusOptions}"
								:readonly="isFinalized"
								v-model="selectedRfi.status">
							</field>

							<field
								label="RFI #"
								col-class="col-md-4"
								:params="{type:'static'}"
								:readonly="true"
								:value="selectedRfiNumberDisplay">
							</field>

							<field
								label="RFI Date"
								col-class="col-md-4"
								:params="{type:'date',initialDate:'today'}"
								:readonly="isFinalized"
								v-model="selectedRfi.rfi_date">
							</field>

							<field
								label="Response Required By"
								col-class="col-md-4"
								:params="{type:'date'}"
								:readonly="isFinalized"
								v-model="selectedRfi.response_deadline">
							</field>


							<field
								label="Subject"
								col-class="col-md-4"
								:readonly="isFinalized"
								v-model="selectedRfi.subject">
							</field>
							
							<field
								label="Question"
								col-class="col-md-4"
								:params="{type:'richtext'}"
								:readonly="isFinalized"
								v-model="selectedRfi.question_content">
							</field>
						</div>

						<div v-show="activeSection == 'Attachments'">
							<outbound-document-files-tab
								:record-id="'id' in selectedRfi ? selectedRfi.id : false"
								file-model="RfiFile"
								record-foreign-key="rfi_id"
								parent-store-location="project"
								parent-file-model="JobFile"
								:size-field="true"
								:readonly="isFinalized"
								v-on:fileSave="previewRefresher++">
							</outbound-document-files-tab>
						</div>
						<div v-show="activeSection == 'Finalizing'">
							<h3>Finalizing</h3>

							<div class="d-flex flex-row justify-content-end align-items-center">
								<p style="margin-right: 10px;margin-bottom: 0">The RFI must be finalized to move onto the delivery step</p>

								<div>
									<button class="btn btn-lg btn-success float-right" type="button" v-on:click="saveRfi(true)">
										<i class="fa fa-lock"></i>
										Finalize RFI
									</button>
								</div>
							</div>

						</div>

						<div style="clear: both;margin-top: 10px;"></div>

						<button v-if="activeSection != menuItems[0]" class="btn btn-light float-left" v-on:click="prevStep" type="button">
							<i class="fa fa-chevron-left"></i> Previous Step
						</button>

						<button v-if="activeSection != menuItems[menuItems.length - 1]" class="btn btn-light float-right" v-on:click="nextStep" type="button">
							Next Step <i class="fa fa-chevron-right"></i>
						</button>

						<div style="clear: both;"></div>
						<comment-thread v-if="'slug' in selectedRfi"
							:parent-slug="selectedRfi.slug"
							parent-model="Rfi"
							:thread-id="'message_thread_id' in selectedRfi ? selectedRfi.message_thread_id : false"
							:thread-subject-reference="threadSubjectRef">
						</comment-thread>
					</vue-form>
				</div>

				<div v-if="activeSection == 'Delivery'" class="col-lg-6">

					<h3>Delivery & Download</h3>

					<p class="text-muted" v-if="selectedRfi.last_emailed">Last emailed {{selectedRfi.last_emailed == 'just now' ? 'just now' : formatDateTimeToLocal(selectedRfi.last_emailed)}}</p>

					<div class="mb-2 d-flex flex-row justify-content-between align-items-center">
						<field label="Status"
							col-class="col-3"
							v-model="selectedRfi.status"
							:params="{type:statusChangerType,options:rfiStatusOptions}"
							v-on:change="statusAutosave"
							v-on:click="statusChangerType = 'select'">
						</field>

						<div>
							<button class="btn btn-light" type="button" v-on:click="deFinalize">
								<i class="fa fa-lock-open"></i>
								De-Finalize for Editing
							</button>
						</div>
					</div>

					<div class="d-flex flex-row flex-wrap mb-4">

						<a v-if="selectedRfi.slug" :href="rfiDLSrc" class="btn btn-light">
							<i class="fa fa-download"></i>
							Download RFI
						</a>

						<button v-if="selectedRfi.status == 'Closed'"
							class="btn btn-light" 
							type="button"
							v-on:click="addToFilesTab">

							<i class="fa fa-file-pdf"></i>
							Add RFI Pdf to Files Tab
						</button>

						<button class="btn btn-success ml-auto" type="button" v-on:click="openEmailModal">
							<i class="fa fa-paper-plane"></i>
							Email RFI
						</button>

					</div>

					<modal-dialog
						:modal-visible="emailRfiModal.visible"
						title="Send RFI By Email"
						confirm-button-text="Send"
						:working="emailRfiModal.working"
						v-on:confirm="emailRfi"
						v-on:closeModal="emailRfiModal.visible = false">

						<field label="Recipients"
							col-class="col-sm-6 col-md-4"
							:params="{type:'select-multi',options:rfiEmailRecipientOptions}"
							v-model="emailRfiModal.recipients">
						</field>

						<additional-email-addresses-field v-model="emailRfiModal.additionalRecipients">
						</additional-email-addresses-field>

						<field
							label="Attach directly"
							col-class="stacked"
							:params="{type:'boolean'}"
							v-model="emailRfiModal.attachDirectly">
						</field>

						<p class="text-muted mb-0">Attach PDF directly to this email (no portal/open tracking).</p>

						<field v-if="responses && responses.length > 0"
							label="Include responses feed in PDF"
							col-class="stacked"
							:params="{type:'boolean'}"
							v-model="emailRfiModal.includeResponsesFeed">
						</field>

					</modal-dialog>

					<comment-thread
						:parent-slug="selectedRfi.slug"
						parent-model="Rfi"
						:thread-id="'message_thread_id' in selectedRfi ? selectedRfi.message_thread_id : false"
						:thread-subject-reference="threadSubjectRef">
					</comment-thread>

					<activity-log
						:editing-log-json="selectedRfi.activity_log_json"
						type-name="RFI">
					</activity-log>
				</div>

				<div class="col-lg-6">
					<div class="d-flex justify-content-between align-items-center mb-2">
						<h3 class="mb-0">
							<template v-if="rightPanelView == 'pdf'">PDF Preview</template>
							<template v-else>Responses</template>
						</h3>
						<div class="d-flex align-items-center">
							<field
								:params="{
									type: 'btn-group',
									buttons: [
										{ icon: 'fa-comments', value: 'responses', title: 'Responses' },
										{ icon: 'fa-file-pdf', value: 'pdf', title: 'PDF Preview' }
									],
									disableNull: true
								}"
								v-model="rightPanelView">
							</field>
						</div>
					</div>

					<div v-if="rightPanelView == 'pdf'">
						<pdf-js v-if="selectedRfi.slug" :url="rfiPreviewSrc" :page="1"></pdf-js>
						<p v-else class="text-muted mb-0">
							PDF preview will appear after the RFI is saved.
						</p>
					</div>
					<div v-show="rightPanelView == 'responses'">
						<div v-if="responses.length == 0" class="text-muted">
							No responses yet.
						</div>
						<div v-else class="list-group">
							<div
								v-for="response in responses"
								:key="response.id"
								class="list-group-item list-group-item-action"
								:class="{'border-warning bg-light': response.is_request_for_more_information == 1}"
								role="button"
								v-on:click="openViewResponseModal(response)">
								<div class="d-flex justify-content-between align-items-center">
									<div>
										<strong>{{ response.responder_name }}</strong>
										<span v-if="response.is_request_for_more_information == 1" class="badge badge-warning ml-2">Request for more info</span>
									</div>
									<div class="d-flex align-items-center text-muted">
										<span v-if="response.RfiFile && response.RfiFile.length" class="mr-2">
											<i class="fa fa-paperclip"></i>
											Files:
											{{ response.RfiFile.length }}
										</span>
										<span v-if="response.is_request_for_more_information == 1">
											{{ formatDateTimeToLocal(response.created_at) }}
										</span>
										<span v-else>{{ formatDateTimeToLocal(response.response_date) }}</span>
									</div>
								</div>
							</div>
						</div>

						<div class="d-flex justify-content-between mt-3">
							<div>
								<button v-if="'id' in selectedRfi && selectedRfi.id && selectedRfi.status != 'Closed'" class="btn btn-success" type="button" v-on:click="openAddResponseModal">
									<i class="fa fa-plus"></i>
									Request for More Info/Manual Response
								</button>
							</div>
							<div>
								<button v-if="showingArchivedResponses"
									type="button" 
									class="btn btn-sm btn-light"
									v-on:click="fetchRfiResponses(selectedRfi.id,false);showingArchivedResponses = false">
									Hide Archived Responses	
								</button>
								<button v-else
									type="button" 
									class="btn btn-sm btn-light"
									v-on:click="fetchRfiResponses(selectedRfi.id,true);showingArchivedResponses = true">
									Show Archived Responses
								</button>
							</div>
						</div>

					</div>

				</div>
			</div>
		</template>
	</collapsible-panel>

	<modal-dialog
		:modal-visible="addResponseModal.visible"
		modal-size="modal-lg"
		:title="addResponseModalTitle"
		confirm-button-text="Save"
		:cancel-button-text="addResponseModal.readonly ? 'Close' : 'Done'"
		:submit-visible="!addResponseModal.readonly"
		:working="addResponseModal.working"
		v-on:confirm="saveAddResponse"
		v-on:closeModal="closeAddResponseModal">

		<field
			label="Type"
			col-class="col-md-3"
			:params="{type:'boolean', doubleLabels: ['Response', 'Request for more information']}"
			:readonly="addResponseModal.readonly"
			v-model="addResponseModal.payload.is_request_for_more_information"
			v-on:change="addResponseTypeChange">
		</field>

		<field
			:label="responseType + ' Body'"
			col-class="col-md-3"
			:params="{type:'richtext'}"
			:readonly="addResponseModal.readonly"
			v-model="addResponseModal.payload.response_content">
		</field>

		<field v-if="addResponseModal.payload.is_request_for_more_information == 0 && addResponseModal.readonly"
			:label="responseType + ' Date'"
			col-class="col-md-3"
			:readonly="true"
			:value="formatDateTimeToLocal(addResponseModal.payload.response_date)">
		</field>

		<field v-else-if="addResponseModal.payload.is_request_for_more_information == 0"
			:label="responseType + ' Date'"
			col-class="col-md-3"
			:params="{type:'datetime'}"
			v-model="addResponseModal.payload.response_date">
		</field>

		<field v-if="addResponseModal.payload.is_request_for_more_information == 1"
			label="Response Required By"
			col-class="col-md-3"
			:params="{type:'date'}"
			:readonly="addResponseModal.readonly"
			v-model="addResponseModal.payload.respond_by_date">
		</field>

		<field v-if="!addResponseModal.payload.is_request_for_more_information"
			label="Response By"
			col-class="col-md-3"
			:readonly="addResponseModal.readonly"
			v-model="addResponseModal.payload.responder_name"
			:params="{type:'text',required:true}">
		</field>

		<template v-if="addResponseModal.savedResponseId">
			<outbound-document-files-tab
				:record-id="addResponseModal.savedResponseId"
				file-model="RfiFile"
				record-foreign-key="rfi_response_id"
				parent-store-location="project"
				parent-file-model="JobFile"
				:allow-add-to-parent-files-tab="true"
				:readonly="addResponseModal.readonly"
				v-on:filesChanged="reloadSelectedRfiAfterSave">
			</outbound-document-files-tab>
		</template>
		<p v-else class="text-muted">
			Save the response to attach files.
		</p>

		<div v-if="willShowResendPrompt" class="text-muted text-right mb-0 mt-3">When ready to email, click Done</div>

		<template slot="footer">
			<button v-if="addResponseModal.payload.archived == 0" class="btn btn-warning" type="button" v-on:click="archiveResponse(1)">
				<i class="fa fa-archive"></i>
				Archive Response
			</button>
			<button v-if="addResponseModal.payload.archived == 1" class="btn btn-warning" type="button" v-on:click="archiveResponse(0)">
				<i class="fa fa-archive"></i>
				Un-Archive Response
			</button>
		</template>
	</modal-dialog>

	<modal-dialog
		:modal-visible="resendPromptModalVisible"
		title="Re-send"
		confirm-button-text="Yes"
		cancel-button-text="No"
		:submit-visible="true"
		v-on:confirm="openEmailModal"
		v-on:closeModal="resendPromptModalVisible = false">

		Would you like to re-email the RFI with the request for more information included?

	</modal-dialog>
</div>
</template>

<script type="text/javascript">
import TableList from "@/components/TableList"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"
import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import PdfJs from "@/components/PdfJs"
import CommentThread from "@/components/super_components/CommentThread"
import OutboundDocumentFilesTab from "@/components/super_components/OutboundDocumentFilesTab"
import AdditionalEmailAddressesField from "@/components/AdditionalEmailAddressesField"
import ActivityLog from "@/components/ActivityLog"

import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "Rfis",
	mixins: [ContactMixins],
	props: ["selectedRfiSlug"],
	components: {
		TableList,
		CollapsiblePanel,
		PanelMenu,
		VueForm,
		Field,
		ModalDialog,
		PdfJs,
		CommentThread,
		OutboundDocumentFilesTab,
		AdditionalEmailAddressesField,
		ActivityLog
	},
	data() {
		return {
			rfiCustomerSubcontactsForEmail: [],
			showList: true,
			activeSection: "Details",
			rightPanelView: "responses",
			working: false,
			statusChangerType: "editable-static",
			previewRefresher: 1,
			rfis: [],
			selectedRfi: {},
			showingArchivedResponses: false,
			emailRfiModal: {
				visible: false,
				additionalRecipients: [],
				recipients: [],
				attachDirectly: false,
				includeResponsesFeed: true,
				working: false
			},
			addResponseModal: {
				visible: false,
				working: false,
				readonly: false,
				savedResponseId: null,
				changesMade: false,
				payload: {
					rfi_id: null,
					response_content: "",
					response_date: "",
					respond_by_date: "",
					responder_name: "",
					is_request_for_more_information: false,
					archived: 0
				}
			},
			resendPromptModalVisible: false,
			rfiStatusOptions: [
				{text: "Draft", value: "Draft"},
				{text: "Un-Issued", value: "Un-Issued"},
				{text: "Issued", value: "Issued"},
				{text: "Awaiting Information", value: "Awaiting Information"},
				{text: "Responded", value: "Responded"},
				{text: "Closed", value: "Closed"}
			],
			fields: [
				{label: "RFI #", key: "fullRfiNum"},
				{label: "RFI Date", key: "rfiDate"},
				{label: "Subject", key: "subject"},
				{label: "Response Required By", key: "responseRequiredBy"},
				{label: "Last Response Date", key: "lastResponseDate"},
				{label: "Status", key: "statusDisplay"}
			]
		}
	},
	watch: {
		"$store.project"() {
			if ("id" in this.$store.project)
				this.fetchData()
		},
		menuItems: {
			handler() {
				if (this.menuItems.indexOf(this.activeSection) === -1)
					this.activateSection(this.menuItems[0] || "Details")
			},
			immediate: true
		}
	},
	computed: {
		isFinalized() {
			return "is_finalized" in this.selectedRfi && this.selectedRfi.is_finalized == 1
		},
		responseType() {
			if (this.addResponseModal.payload.is_request_for_more_information)
				return "Request for More Info"
			return "Response"
		},
		threadSubjectRef() {
			if ("Job" in this.selectedRfi && this.selectedRfi.Job)
				return "RFI: Project #" + this.selectedRfi.Job.job_num
			else if (this.selectedRfi && "subject" in this.selectedRfi && this.selectedRfi.subject)
				return "RFI: " + this.selectedRfi.subject
			else
				return "RFI"
		},
		rfiPreviewSrc() {
			if (!this.selectedRfi.slug)
				return ""
			let includeResponsesFeed = 1
			if (this.emailRfiModal && this.emailRfiModal.includeResponsesFeed == 0)
				includeResponsesFeed = 0
			return window.apiBase + "Rfi/pdf?slug=" + this.selectedRfi.slug + "&token=" + this.$store.sessionToken + "&humanReadable=true&includeResponsesFeed=" + includeResponsesFeed + "&v=" + this.previewRefresher
		},
		rfiDLSrc() {
			let includeResponsesFeed = 1
			if (this.emailRfiModal && this.emailRfiModal.includeResponsesFeed == 0)
				includeResponsesFeed = 0
			return window.apiBase + "Rfi/pdf?slug=" + this.selectedRfi.slug + "&token=" + this.$store.sessionToken + "&humanReadable=true&includeResponsesFeed=" + includeResponsesFeed + "&download=true"
		},
		rfiEmailRecipientOptions() {
			let customer = this.$store.project.Customer
			let sub = this.rfiCustomerSubcontactsForEmail
			let contacts = []

			if (customer && customer.email)
				contacts = contacts.concat(this.documentEmailRecipients(customer, sub))

			if (this.$store.project.JobContact) {
				let jobContacts = this.$store.project.JobContact.map(jobContact => jobContact.Contact).filter(contact => contact && contact.email)

				contacts = contacts.concat(this.optionify(jobContacts.map(contact => ({
					id: contact.id,
					display: contact.name + " (" + contact.email + ")"
				})), "display"))
			}

			let seen = {}
			return contacts.filter(contact => {
				if (seen[contact.value])
					return false
				seen[contact.value] = true
				return true
			})
		},
		menuItems() {
			let tabs = [
				"Details",
				"Attachments"
			]

			if ("is_finalized" in this.selectedRfi && this.selectedRfi.is_finalized == 1)
				tabs.push("Delivery")
			else
				tabs.push("Finalizing")

			return tabs
		},
		addResponseModalTitle() {
			let title = this.addResponseModal.readonly ? "Response" : "Add a Response"

			if (this.addResponseModal.payload.archived == 1)
				title += " (Archived)"

			return title
		},
		selectedRfiNumberDisplay() {
			if (!("id" in this.selectedRfi) || !this.selectedRfi.id)
				return "(assigned on save)"

			let jobNum = this.$store.project.job_num
			if ("Job" in this.selectedRfi && this.selectedRfi.Job && this.selectedRfi.Job.job_num)
				jobNum = this.selectedRfi.Job.job_num

			if (this.selectedRfi.rfi_num === undefined || this.selectedRfi.rfi_num === null || this.selectedRfi.rfi_num === "")
				return "—"

			return jobNum + "-" + this.selectedRfi.rfi_num
		},
		mutatedRfis() {
			let vm = this
			return this.rfis.map(rfi => {
				let jobNum = vm.$store.project.job_num
				if ("Job" in rfi && rfi.Job && rfi.Job.job_num)
					jobNum = rfi.Job.job_num

				rfi.fullRfiNum = (rfi.rfi_num !== undefined && rfi.rfi_num !== null && rfi.rfi_num !== "")
					? jobNum + "-" + rfi.rfi_num
					: "—"

				rfi.rfiDate = vm.formatDate(rfi.rfi_date)

				let responseRequiredByDate = ""
				if (!("RfiResponse" in rfi) || !rfi.RfiResponse || rfi.RfiResponse.length == 0) {
					responseRequiredByDate = rfi.response_deadline
				}
				else {
					let bestCreatedAt = null
					for (let response of rfi.RfiResponse) {
						if (!response.respond_by_date || response.respond_by_date == "0000-00-00")
							continue
						let createdAt = response.created_at || ""
						if (bestCreatedAt === null || createdAt > bestCreatedAt) {
							bestCreatedAt = createdAt
							responseRequiredByDate = response.respond_by_date
						}
					}
				}
				rfi.responseRequiredBy = vm.formatDate(responseRequiredByDate)

				let lastResponseDate = ""
				if ("RfiResponse" in rfi && rfi.RfiResponse && rfi.RfiResponse.length > 0)
					lastResponseDate = rfi.RfiResponse[0].response_date || rfi.RfiResponse[0].created_at

				rfi.lastResponseDate = vm.formatDateTimeToLocal(lastResponseDate)

				rfi.statusDisplay = rfi.status ? rfi.status : "Draft"

				return rfi
			})
		},
		willShowResendPrompt() {
			if (this.addResponseModal.savedResponseId > 0 && this.addResponseModal.payload.is_request_for_more_information == 1 && this.addResponseModal.changesMade)
				return true

			return false
		},
		responses() {
			if ("RfiResponse" in this.selectedRfi && this.selectedRfi.RfiResponse)
				return this.selectedRfi.RfiResponse

			return []
		},
	},
	methods: {
		prevStep() {
			this.activateSection(this.menuItems[this.menuItems.indexOf(this.activeSection) - 1])
		},
		nextStep() {
			let vm = this
			if (!("id" in this.selectedRfi) && this.activeSection == "Details") {
				this.saveRfi().then(response => {
					vm.$nextTick(() => {
						vm.activateSection(vm.menuItems[vm.menuItems.indexOf(vm.activeSection) + 1])
					})
				})
			}
			else
				this.activateSection(this.menuItems[this.menuItems.indexOf(this.activeSection) + 1])
		},
		activateSection(item) {
			this.activeSection = item
			if (this.activeSection == "Delivery")
				this.statusChangerType = "editable-static"
		},
		newRfi() {
			this.selectedRfi = {
				job_id: this.$store.project.id,
				rfi_date: (new Date()).toISOString().split("T")[0],
				created_by: this.$store.userDetails.id,
				status: "Draft"
			}
			this.activeSection = "Details"
			this.showList = false

			window.history.pushState({},"","/project/"+this.$route.params.id+"/rfis/new")
		},
		editRfi(rfi) {
			this.selectedRfi = rfi
			this.activeSection = "Details"
			this.showList = false

			window.history.pushState({},"","/project/"+this.$route.params.id+"/rfis/" + this.selectedRfi.slug)
		},
		backToList() {
			window.history.pushState({},"","/project/"+this.$route.params.id+"/rfis")
			
			this.showList = true
		
		},
		reloadSelectedRfiAfterSave() {
			let vm = this
			if (!("slug" in this.selectedRfi) || !this.selectedRfi.slug)
				return

			let params = {
				include: [
					{ model: "RfiResponse", include: ["User", { model: "RfiFile", include: ["LibraryUpload"] }] },
					"User",
					{ model: "Job", fields: ["id", "job_num", "slug"] }
				]
			}

			this.getJSON("Rfi/find/" + this.selectedRfi.slug, params, true).then(response => {
				if (response.success) {
					vm.selectedRfi = response.data
					vm.previewRefresher++
				}
			})
		},
		deFinalize() {
			let vm = this

			let payload = {
				id: this.selectedRfi.id,
				is_finalized: 0
			}

			this.postData("Rfi/save", payload, true).then(response => {
				if (response.success) {
					vm.alertSaved("RFI de-finalized")

					vm.selectedRfi.is_finalized = 0

					if (vm.activeSection == "Delivery")
						vm.activeSection = "Finalizing"
				}
			})
		},
		statusAutosave(value) {
			let vm = this

			let payload = {
				id: this.selectedRfi.id,
				status: value
			}

			this.postData("Rfi/save", payload, true).then(response => {
				if (response.success) {
					vm.alertSaved("RFI status changed")
					vm.statusChangerType = "editable-static"
				}

			})
		},
		openEmailModal() {
			let vm = this

			this.activeSection = 'Delivery'
			this.resendPromptModalVisible = false
			this.emailRfiModal.additionalRecipients = []
			this.emailRfiModal.recipients = []
			this.emailRfiModal.attachDirectly = false
			this.emailRfiModal.includeResponsesFeed = true
			this.rfiCustomerSubcontactsForEmail = []
			this.emailRfiModal.visible = true

			if (this.$store.project.customer_id) {
				this.getJSON("Contact/find/" + this.$store.project.customer_id, { include: ["SubContacts"] }).then(response => {
					if (response.success && response.data.SubContacts)
						vm.rfiCustomerSubcontactsForEmail = response.data.SubContacts
				})
			}
		},
		emailRfi() {
			let vm = this

			this.emailRfiModal.working = true

			let attachDirectly = this.emailRfiModal.attachDirectly == 1 || this.emailRfiModal.attachDirectly === true
			let includeResponsesFeed = this.emailRfiModal.includeResponsesFeed == 1 || this.emailRfiModal.includeResponsesFeed === true

			let payload = {
				rfi_id: this.selectedRfi.id,
				additional: this.emailRfiModal.additionalRecipients.join(","),
				recipients: this.emailRfiModal.recipients,
				attachDirectly: attachDirectly ? 1 : 0,
				includeResponsesFeed: includeResponsesFeed ? 1 : 0
			}

			this.postData("Rfi/send", payload).then(response => {
				vm.emailRfiModal.working = false

				if (response.success) {
					vm.alertSuccess("RFI sent!")
					vm.emailRfiModal.visible = false
					vm.selectedRfi.last_emailed = response.time
					vm.selectedRfi.status = 'Issued'
				}
			})
		},
		saveRfi(finalize) {
			let vm = this
			let fieldsToUse = [
				"id",
				"job_id",
				"rfi_date",
				"subject",
				"question_content",
				"created_by",
				"response_deadline",
				"status"
			]

			let payload = {}
			fieldsToUse.forEach(field => {
				if (field in vm.selectedRfi)
					payload[field] = vm.selectedRfi[field]
			})

			if (!("job_id" in payload))
				payload.job_id = this.$store.project.id

			if (!("created_by" in payload))
				payload.created_by = this.$store.userDetails.id

			if (finalize)
				payload.is_finalized = 1

			this.working = true

			return new Promise((resolve, reject) => {
				vm.postData("Rfi/save", payload, true).then(response => {
					if (response.success) {
						vm.alertSaved("RFI saved")

						if (finalize) {
							vm.selectedRfi.is_finalized = 1
							if (vm.activeSection == "Finalizing")
								vm.activeSection = "Delivery"
						}

						if (!("id" in payload)) {
							window.history.pushState({},"","/project/"+vm.$route.params.id+"/rfis/"+response.data.slug)
							vm.selectedRfi.id = response.data.record_id
							vm.selectedRfi.slug = response.data.slug
						}

						vm.reloadSelectedRfiAfterSave()
						resolve(response)
					}

					vm.working = false
				})
			})
		},
		archiveResponse(archiveFlagValue) {
			let vm = this

			let payload = {
				id: this.addResponseModal.savedResponseId,
				archived: archiveFlagValue
			}

			this.postData("RfiResponse/save",payload).then(response => {
				if (response.success) {

					if (archiveFlagValue == 1)
						vm.alertSuccess("Response archived")
					else
						vm.alertSuccess("Response un-archived")

					vm.addResponseModal.visible = false
					vm.fetchRfiResponses(vm.selectedRfi.id)
				}
			})
		},
		addResponseTypeChange(isRequest) {
			if (isRequest)
				this.addResponseModal.payload.responder_name = this.$store.userDetails.first_name + '  ' + this.$store.userDetails.last_name
		},
		openAddResponseModal() {
			this.addResponseModal.readonly = false
			this.addResponseModal.payload = {
				rfi_id: this.selectedRfi.id,
				response_content: "",
				response_date: this.moment().format("YYYY-MM-DD HH:mm"),
				respond_by_date: "",
				responder_name: "",
				is_request_for_more_information: false,
				archived: 0
			}
			this.addResponseModal.savedResponseId = null
			this.addResponseModal.visible = true
			this.addResponseModal.changesMade = false
		},
		openViewResponseModal(response) {
			let payload = {
				id: response.id,
				rfi_id: this.selectedRfi.id,
				response_content: response.response_content || "",
				response_date: response.response_date || "",
				respond_by_date: response.respond_by_date || "",
				responder_name: response.responder_name || "",
				is_request_for_more_information: response.is_request_for_more_information == 1,
				archived: response.archived
			}
			if (!payload.responder_name && response.User)
				payload.responder_name = response.User.first_name + " " + response.User.last_name

			this.addResponseModal.readonly = true
			this.addResponseModal.payload = payload
			this.addResponseModal.savedResponseId = response.id
			this.addResponseModal.visible = true
		},
		closeAddResponseModal() {
			this.addResponseModal.visible = false

			if (this.addResponseModal.savedResponseId > 0 && this.addResponseModal.payload.is_request_for_more_information == 1 && this.addResponseModal.changesMade)
				this.resendPromptModalVisible = true
		},
		saveAddResponse() {
			let vm = this

			if (this.addResponseModal.readonly)
				return

			let payload = this.cloneObj(this.addResponseModal.payload)
			if (this.addResponseModal.savedResponseId)
				payload.id = this.addResponseModal.savedResponseId

			this.addResponseModal.working = true

			this.postData("RfiResponse/save", payload, true).then(response => {
				vm.addResponseModal.working = false
				vm.addResponseModal.changesMade = true

				if (response.success) {
					vm.alertSaved("Response saved")

					if (response.data.record_id) {
						vm.addResponseModal.savedResponseId = response.data.record_id
						vm.$set(vm.addResponseModal.payload, "id", response.data.record_id)
					}

					vm.reloadSelectedRfiAfterSave()
					vm.fetchRfis(false)
				}
			})
		},
		addToFilesTab() {
			let vm = this 
			this.postData("Rfi/add-pdf-to-files",{id: this.selectedRfi.id}).then(response => {
				if (response.success)
					vm.alertSuccess("RFI pdf sent to files tab!");
			})
		},
		fetchRfis(spinner) {
			let vm = this
			let params = {
				filters: [
					["job_id", this.$store.project.id]
				],
				include: [
					{
						model: "RfiResponse",
						include: ["User"]
					},
					"User",
					{ model: "Job", fields: ["id", "job_num", "slug"] }
				],
				orders: [
					["rfi_num", "DESC"]
				]
			}

			return new Promise((resolve,reject) => {
				this.getJSON("Rfi/get", params, spinner).then(response => {
					if (response.success)
						vm.rfis = response.data

					resolve(response)

					return response
				})
			})
		},
		fetchData() {
			this.spinner(true)

			this.fetchRfis(false).then(responses => {
				this.spinner(false)
			})
		},
		fetchRfi(slug) {
			let params = {
				include: [
					{ 
						model: "RfiResponse", 
						include: ["User", { model: "RfiFile", include: ["LibraryUpload"] }]
					},
					"User",
					{ model: "Job", fields: ["id", "job_num", "slug"] }
				]
			}

			return this.getJSON("Rfi/find/" + slug, params, true)
		},
		fetchRfiResponses(rfiId, includeArchived) {
			let vm = this 

			let params = {
				filters: [
					["rfi_id", rfiId]
				],
				include: ["User", { model: "RfiFile", include: ["LibraryUpload"] }]
			}

			if (!includeArchived)
				params.filters.push(["archived",0])

			this.getJSON("RfiResponse/get",params).then(response => {
				if (response.success)
					vm.selectedRfi.RfiResponse = response.data
			})
		}
	},
	created() {
		let vm = this

		if ("id" in this.$store.project)
			this.fetchData()

		if (this.selectedRfiSlug) {
			if (this.selectedRfiSlug == "new")
				this.newRfi()
			else {
				this.fetchRfi(this.selectedRfiSlug).then(response => {
					if (response.success)
						vm.editRfi(response.data)
				})
			}
		}

		if (this.$route.name == "ProjectWithSubmenus") {
			this.showList = false
		}
	}
}
</script>

<style scoped>
.close-edit {
	position: absolute;
	top: 10px;
	right: 0;
	z-index: 1;
}
</style>
